
(function statusDefinition() {
    'use strict';
    angular.module('Entities')
        .service('statusService', [
            'restUrlBuilder', 'authExtend',
            function statusService(restUrlBuilder, auth) {
                var auditRestUrlBuilder = restUrlBuilder('audit');
                var authRestUrlBuilder = restUrlBuilder('auth');
                var notifRestUrlBuilder = restUrlBuilder('notif');
                var cppRestUrlBuilder = restUrlBuilder('cpp');
                var processRestUrlBuilder = restUrlBuilder('process');
                var restUrlBuilderwf = restUrlBuilder('wf'); 

               this.getCppVersion = function getCppVersion() {
                    return cppRestUrlBuilder.all('version').get();
                }

                this.getCppStatus = function getCppStatus() {
                    return cppRestUrlBuilder.all('status').get();
                }

                this.getCppUrl = function getCppUrl() {
                    return cppRestUrlBuilder.url;
                }

                this.getProcessVersion = function getProcessVersion() {
                    return processRestUrlBuilder.all('version').get();
                }

                this.getProcessStatus = function getProcessStatus() {
                    return processRestUrlBuilder.all('status').get();
                }

                this.getProcessUrl = function getProcessUrl() {
                    return processRestUrlBuilder.url;
                }

                this.getEdrVersion = function getEdrVersion() {
                    return restUrlBuilder.all('version').get();
                };

                this.getEdrStatus = function getEdrStatus() {
                    return restUrlBuilder.all('status').get();
                };
                
                this.getEdrUrl = function getEdrUrl() {
                    return restUrlBuilder().url;
                };

                this.getWfStatus = function getWfStatus() {
                    return restUrlBuilderwf.all('status').get();
                };

                this.getWfUrl = function getWfUrl() {
                    return restUrlBuilderwf.url;
                };

                this.getWfVersion = function getWfVersion() {
                    return restUrlBuilderwf.all('version').get();
                };

                this.getAuditVersion = function getAuditVersion() {
                    return auditRestUrlBuilder.all('version').get();
                };

                this.getAuditStatus = function getAuditStatus() {
                    return auditRestUrlBuilder.all('status').get();
                };

                this.getAuditUrl = function getAuditUrl() {
                    return auditRestUrlBuilder.url;
                };

                this.getAuthVersion = function getAuthVersion() {
                    return authRestUrlBuilder.all('version').get();
                };

                this.getAuthStatus = function getAuthStatus() {
                    return authRestUrlBuilder.all('status').get();
                };

                this.getAuthUrl = function getAuthUrl() {
                    return authRestUrlBuilder.url;
                };

                this.getNotifVersion = function getNotifVersion() {
                    return notifRestUrlBuilder.all('version').get();
                };

                this.getNotifStatus = function getNotifStatus() {
                    return notifRestUrlBuilder.all('status').get();
                };

                this.getNotifUrl = function getNotifUrl() {
                    return notifRestUrlBuilder.url;
                };

                this.downloadLog = function downloadLog(system) {
                    if (system === 'WF') {
                        return restUrlBuilderwf.all('log/download').get();
                    }

                    if (system === 'Process') {
                        return processRestUrlBuilder.all('log/download').get();
                    }

                    if (system === 'Audit') {
                        return auditRestUrlBuilder.all('log/download').get();
                    }

                    if (system === 'Auth') {
                        return authRestUrlBuilder.all('log/download').get();
                    }

                    if (system === 'CPP') {
                        return cppRestUrlBuilder.all('log/download').get();
                    }

                    if (system === 'EDR') {
                        return restUrlBuilder.all('log/download').get();
                    }

                    return restUrlBuilderwf.all('log/download').get();
                };

                this.getAuthKeyInfo = function getAuthKeyInfo() {
                    return authRestUrlBuilder.all('keys').get();
                }

                this.getWfKeyInfo = function getWfKeyInfo() {
                    return restUrlBuilderwf.all('keys').get();
                }

                this.getEdrKeyInfo = function getEdrKeyInfo() {
                    return restUrlBuilder.all('keys').get();
                }

                this.getAuditKeyInfo = function getAuditKeyInfo() {
                    return auditRestUrlBuilder.all('keys').get();
                }

                this.getCppKeyInfo = function getCppKeyInfo() {
                    return cppRestUrlBuilder.all('keys').get();
                }

                this.getProcessKeyInfo = function getProcessKeyInfo() {
                    return processRestUrlBuilder.all('keys').get();
                }

                this.getNotifKeyInfo = function getNotifKeyInfo() {
                    return notifRestUrlBuilder.all('keys').get();
                }

                this.getAuthDauSqlVersion = function getAuthDauSqlVersion() {
                    return authRestUrlBuilder.all('dauVersion').get();
                }

                this.getWfDauMongoVersion = function getWfDauMongoVersion() {
                    return restUrlBuilderwf.all('mongoDauVersion').get();
                }

                this.getEdrDauSqlVersion = function getEdrDauSqlVersion() {
                    return restUrlBuilder.all('dauVersion').get();
                }

                this.getEdrDauMongoVersion = function getEdrDauMongoVersion() {
                    return restUrlBuilder.all('mongoDauVersion').get();
                }

                this.getAuditDauMongoVersion = function getAuditDauMongoVersion() {
                    return auditRestUrlBuilder.all('mongoDauVersion').get();
                }

                this.getCppDauSqlVersion = function getCppDauSqlVersion() {
                    return cppRestUrlBuilder.all('dauVersion').get();
                }

                this.getProcessDauMongoVersion = function getProcessDauMongoVersion() {
                    return processRestUrlBuilder.all('mongoDauVersion').get();
                }

                this.getNotifDauMongoVersion = function getNotifDauMongoVersion() {
                    return notifRestUrlBuilder.all('mongoDauVersion').get();
                }
            }
        ]);
})();